export default __webpack_public_path__ + "static/media/Group 1110 (1).c36c1352.svg";